const utils = require('frontend-controller/lib/utils')

module.exports = {
	events: {
		add: {
			type: 'click',
			selector: 'button.add',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var newSegmentDataListEntry = {
					data: {
						attributes: {}
					},
					dataIndex: self.getNextFreeDataIndex()
				};
				self.childChanged(newSegmentDataListEntry);
				self.performAndStoreAction(
					undefined,
					self.prepareAction(
						'add_segmentData', undefined, {
							additionalDataComponent: self.model.additionalDataComponent
						}, {
							source: {
								load: {
									componentData: {
										resourceData: {
											data: newSegmentDataListEntry.data
										},
										model: {
											additionalFields: self.model.additionalFields,
											dataIndex: newSegmentDataListEntry.dataIndex,
										}
									}
								}
							}
						}
					)
				)
			}
		},

		change: function(event){
			event.stopImmediatePropagation();
		}
	},

	model: {
		isLoading: true
	},

	methods: {
		dataDealer: function(){
			var self = this;

			self.closest('templates_propertiesForms_segmentPropertiesForm', function(formComponent) {
				var data = (formComponent.resourceData || {}).data || {};
				var dirtyData = (formComponent.model.dirtyFields || {}).data || {};

				self.resourceData = utils.merge(
					(data.children || {}).nl_segmentsData || {},
					((dirtyData).children || {}).nl_segmentsData || {}
				);

				self.model.additionalFields = self.getResourceRegisterContent('mailingListAdditionalFields');
				self.model.additionalDataComponent = self.getResourceRegisterContent('additionalDataComponent');
			});
		},

		// TODO: sanitizeResources necessary to write resourceData??!!
		sanitizeResources: function(){},

		childChanged: function(valueDefinition){
			var self = this;
			self.closest('templates_propertiesForms_segmentPropertiesForm', function(formComponent){
				formComponent.model.dirtyFields.data 															= formComponent.model.dirtyFields.data || {};
				formComponent.model.dirtyFields.data.children 													= formComponent.model.dirtyFields.data.children || {};
				formComponent.model.dirtyFields.data.children.nl_segmentsData 									= formComponent.model.dirtyFields.data.children.nl_segmentsData || {};
				formComponent.model.dirtyFields.data.children.nl_segmentsData.data 								= formComponent.model.dirtyFields.data.children.nl_segmentsData.data || [];
				formComponent.model.dirtyFields.data.children.nl_segmentsData.data[valueDefinition.dataIndex] 	= valueDefinition.data;

				if(utils.isEqual(
					formComponent.model.dirtyFields.data.children.nl_segmentsData,
					((formComponent.resourceData.data || {}).children || {}).nl_segmentsData || {},
				)){
					formComponent.setClean();
				} else {
					formComponent.setDirty();
				}
			});
		},

		getNextFreeDataIndex: function(){
			var self = this;
			var start = ((self.resourceData || {}).data || []).length;
			var dataIndex = start;
			self.closest('templates_propertiesForms_segmentPropertiesForm', function(formComponent){
				var dirtyData = (((((formComponent.model || {}).dirtyFields || {}).data || {}).children || {}).nl_segmentsData || {}).data || [];
				var end = start + dirtyData.length
				for(dataIndex = start; dataIndex < end; dataIndex++){
					if(!dirtyData[dataIndex]){
						break;
					}
				}
			});
			return dataIndex;
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;

			if((options || {}).refresh) {
				self.triggerFind('onRefreshDone');
			} else {
				var segmentData, d;
				var segmentDataPromises = [];
				for(d in self.resourceData.data || []){
					if((segmentData = self.resourceData.data[d]) !== null){
						segmentDataPromises.push(self.performAndStoreAction(
							undefined,
							self.prepareAction(
								'add_segmentData', undefined, {
									additionalDataComponent: self.model.additionalDataComponent
								}, {
									source: {
										load: {
											componentData: {
												resourceData: {
													data: segmentData
												},
												model: {
													additionalFields: self.model.additionalFields,
													dataIndex: d
												}
											}
										}
									}
								}
							)
						));
					}
				}

				utils.promise.performAllChains(self, { chain: segmentDataPromises }).then(function(){
					$element.removeClass('isLoading');
				});
			}
		},
		fieldNameUpdated: function($element, opions){
			$element.removeClass('isLoading');
		},

		onChildChanged: function($element, options){
			this.childChanged(options);
		}
	}
}